import _ from "lodash";
import {SHOPIFY_PRODUCT_IMAGES_PATH} from "../../shopify/constants/shopify.constant";
import {PINTEREST_IMAGES_PATH} from "../constants/pinterest.constant";

export {
    preparePinterestImageFilePath
}

const preparePinterestImageFilePath = (designInfo) => {
    const filePath = [];
    filePath.push(_.kebabCase(PINTEREST_IMAGES_PATH));
    filePath.push(_.kebabCase(designInfo.parent));
    filePath.push(_.kebabCase(designInfo.themeName));
    filePath.push(_.kebabCase(designInfo.quoteName));

    return _.join(_.compact(filePath), '/');
}
